import React from 'react';
import TertiaryCustomButton from '../../../../../commons/tertiary-custom-button/tertiary-custom-button';

/**
 * FooterSectionItem
 * Renders the footer-style submenu:
 * - Multiple section groups (title + links)
 * - A featured gray box with title/description/CTA
 */
export default function FooterSectionItem({ sections = [], featured = null }) {
  return (
    <li className="footer-section-item">
      {/* Section groups */}
      {sections.map((section, idx) => {
        const links = section.links || section.items || [];
        return (
          <div key={idx} className="footer-menu-section mb-4">
            {section.title && (
              <p className="font-semibold">
                {section.title}
              </p>
            )}
            {Array.isArray(links) && links.length > 0 && (
              <ul>
                {links.map((link, lIdx) => {
                  if (!link?.href || !link?.text) return null;
                  return (
                    <li key={lIdx}>
                      <TertiaryCustomButton
                        classes={'customize-tertiary-cls footer-detail-ancor'}
                        href={link.href}
                        title={link.text}
                      />
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        );
      })}

      {/* Featured content block (gray box) */}
      {featured && (
        <div className="footer-featured">
          {featured.title && <div className='footer-featured-header'>{featured.title}</div>}
          {featured.description && <p>{featured.description}</p>}
          {featured.cta?.href && featured.cta?.text && (
            // <a href={featured.cta.href} className="footer-cta">
            //   {featured.cta.text}
            // </a>
            <TertiaryCustomButton
              classes={
                'customize-tertiary-cls footer-featured-popup-footer-btn'
              }
              href={featured.cta.href}
              title={featured.cta.text}
            />
          )}
        </div>
      )}
    </li>
  );
}
